import { apiSlice } from "./apiSlice";
import config from "../../config.json";

export const formsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    sendEditReqFormLibrary: builder.mutation({
      query: ({ id, notes }) => ({
        url: (config.SendRequestEditFormLibrary || "") + id + "&notes=" + notes,
        method: "GET",
        responseHandler: "text",
      }),
      invalidatesTags: ["FormLibrary"],
    }),
  }),
});

export const {
  useSendEditReqFormLibraryMutation,
} = formsApiSlice;
